import React from "react";

const PageContainer = ({ children, className = "", style, narrow = false, ...rest }) => (
  <div
    className={`pg-container ${className}`}
    style={{
      marginTop: "2rem",
      ...(narrow ? { maxWidth: 960 } : {}),
      ...style,
    }}
    {...rest}
  >
    {children}
  </div>
);

export default PageContainer;